import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import type { CreateBuilderRoomRequest } from 'app/typings/core/builder/roomForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCreateBuilderRoom(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateBuilderRoomRequest) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createRoom, params: { id: hotelId.toString() } },
        payload
      ) as Promise<RoomResponse>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.builderRooms, { id: hotelId }],
      });
      message.success('Room successfully created');
    },
    onError: () => {
      message.error('Failed to create room');
    },
  });
}
